import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { DateTimeService } from '../../services/date-time.service';
import { UserInfoService } from '../../services/user-info.service';
import { StorageService } from '../../services/storage.service';
import { DateFormat } from '../../interfaces/base-core-services.interface';
import { Validations } from '../../constants/validations.constant';
import * as _ from 'lodash';

@Component({
  selector: 'app-refund-approval',
  templateUrl: './refund-approval.component.html',
})
export class RefundApprovalComponent implements OnInit {

  public refundApprovalGroup: FormGroup;
  public refundStatusList: any[] = [];
  public rejectionReasonList: any[] = [];
  public formData:any = { 'variables': {} };
  public goodsDetailAction = [];
  public load = false;
  public showrejectionReason = false;
  public showRemarks = false;
  public showApprovedAmount = false;
  public totalRefundAmount:any;
  @Input() public defaultFormData: any;
  @Output() public submitedFormData = new EventEmitter<FormData>();

  constructor(private formBuilder: FormBuilder, private dataTimeService: DateTimeService, private storage: StorageService, public userInfo: UserInfoService) { }

  ngOnInit():void {
    if (typeof this.defaultFormData === 'object') {
      this.onLoad(this.defaultFormData);
      this.load = true;

    }

  }

  onLoad(data:any):void {
    this.refundApprovalGroup = this.formBuilder.group({
      refundStatus: [null, [Validators.required]],
      approvedAmount: [null],
      rejectionReason: [null],
      remarks: [null]
    });

    const keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
      if (key.indexOf('ics_ref_reviewer_status') >= 0) {
        this.refundStatusList = data.rdmData[key];
      } else {
        this.rejectionReasonList = data.rdmData[key];
      }
    });

  }

  refundStatusChange(value: string) :void{
    const refundStatus = this.refundApprovalGroup.controls['refundStatus'];
    const rejStatus = this.refundApprovalGroup.controls['rejectionReason'];
    const appRemark = this.refundApprovalGroup.controls['remarks'];
    if (value.includes('REFAPP')) {
      this.showrejectionReason = false;
      this.showApprovedAmount = true;
      refundStatus.setValidators(Validators.required);
      rejStatus.clearValidators();
      appRemark.clearValidators();
      const amountPaid = _.find(this.defaultFormData.variables, (v) => {
        return v.key === 'totalAmountPaid';
      });

      const requestedAmount = _.find(this.defaultFormData.variables, (v) => {
        return v.key === 'requestedRefundAmount';
      });
    
      if (amountPaid !== null && requestedAmount !== null) {
        this.totalRefundAmount = Math.min(requestedAmount?.text, amountPaid?.text);
        this.refundApprovalGroup.controls['approvedAmount'].setValidators([
          Validators.required,
          Validators.pattern(Validations.REGEX_INTEGER_WITH_DECIMAL),
          Validators.max(Math.min(requestedAmount.text, amountPaid.text)), // Set the maximum value to the smaller of requestedAmount and amountPaid
        ]);
      }
    } else if (value.includes('REFREJ')) {
      this.showrejectionReason = true;
      this.showApprovedAmount = false;
      rejStatus.setValidators([Validators.required]);
      appRemark.setValidators([Validators.required]);
      refundStatus.clearValidators();
    } else {
      this.showApprovedAmount = false;
      this.showrejectionReason = false;
      rejStatus.clearValidators();
      refundStatus.clearValidators();
    }

  }


  onSubmit() :void{
    for (const i in this.refundApprovalGroup.controls) {
      if(i in this.refundApprovalGroup.controls){
        this.refundApprovalGroup.controls[i].markAsDirty();
        this.refundApprovalGroup.controls[i].updateValueAndValidity();
      }
    }

    if (this.refundApprovalGroup.value.refundStatus !== null) {
      this.formData.variables['status'] = { 'value': this.refundApprovalGroup.value.refundStatus };
    }

    if (this.refundApprovalGroup.value.approvedAmount !== null) {
      this.formData.variables['approvedRefundAmount'] = { 'value': this.refundApprovalGroup.value.approvedAmount };

    }

    if (this.refundApprovalGroup.value.rejectionReason !== null) {
      this.formData.variables['rejectionReasonCode'] = { 'value': this.refundApprovalGroup.value.rejectionReason };
    }

    if (this.refundApprovalGroup.value.remarks !== null) {
      this.formData.variables['reviewerRemarks'] = { 'value': this.refundApprovalGroup.value.remarks };
    }
    this.formData.variables['action'] = { 'value': this.refundApprovalGroup.value.refundStatus };
    this.formData.variables['operation'] = { 'value': 'Approve' };
    this.formData.variables['modifiedBy'] = { 'value': this.userInfo.getUserName() };
    this.formData.variables['modifiedDateAndTime'] = { 'value': this.dataTimeService.getDateFormat(new Date(), DateFormat.MM_DD_YYYY_HH_mm) };


    if (this.refundApprovalGroup.valid) {
      this.submitedFormData.emit(this.formData);
    }

  }


}
